import { render } from "./tip-concent-msg-box.vue?vue&type=template&id=3fdd7209&scoped=true&ts=true"
import script from "./tip-concent-msg-box.vue?vue&type=script&lang=ts"
export * from "./tip-concent-msg-box.vue?vue&type=script&lang=ts"

import "./tip-concent-msg-box.vue?vue&type=style&index=0&id=3fdd7209&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdd7209"]])

export default __exports__